<template>
  <form @submit.prevent="onSubmit">
    <elsa-v-select
      :options="categories"
      v-model="category"
      label="name"
      :reduce="item => item.id"
      :append-to-body="true"
      :clearable="false"
      html-label="Тип"
    />
    <div class="text-center mt-4">
      <app-button>Изменить тип</app-button>
    </div>
  </form>
</template>

<script>
import modalContext    from "@/mixins/modalContext";
import notifyHttpError from "@/mixins/notifyHttpError";

export default {
  name:     "IssueChangeCategoryModal",
  mixins:   [modalContext, notifyHttpError],
  props:    ['issue', 'onChangeCategory'],
  data() {
    return {
      category:   this.issue.category_id,
      isProgress: false,
    };
  },
  computed: {
    categories() {
      return Object.values(this.$store.getters['common/tasks/newCategories']);
    },
  },
  methods:  {
    onSubmit() {
      if (this.isProgress) return;

      this.isProgress = true;
      this.onChangeCategory(this.category).then(
        () => this.modalResolve(),
        this.notifyHttpError,
      ).finally(() => this.isProgress = false);
    },
  },
};
</script>

<style lang="scss" module>
</style>
